import { Alert, Button, ButtonProps } from "@mui/material";

import BaseCard, { BaseCardProps } from "../BaseCard/base-card";

type Props = {
  retry?: ButtonProps;
  error: string | Error;
} & Partial<Pick<BaseCardProps, "title" | "action">>;

function ErrorCard(props: Props): React.JSX.Element {
  return (
    <BaseCard
      data-testid="ds-error-card"
      title={props.title}
      action={
        props.retry ? (
          <Button
            data-testid="ds-error-card-retry-button"
            variant="contained"
            {...props.retry}
          >
            Retry
          </Button>
        ) : null
      }
    >
      <Alert data-testid="ds-error-card-alert" severity="error">
        {typeof props.error === "string" ? props.error : props.error.message}
      </Alert>
    </BaseCard>
  );
}

export { ErrorCard };
